/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsSocialLinksDtoSchema = z.object({
  x: z.string().nullish(),
  discord: z.string().nullish(),
  youtube: z.string().nullish(),
  twitch: z.string().nullish(),
  telegram: z.string().nullish(),
  steam: z.string().nullish(),
  vk: z.string().nullish(),
});
